import { render } from "./perfil.vue?vue&type=template&id=64d65d5f&scoped=true"
import script from "./perfil.vue?vue&type=script&lang=js"
export * from "./perfil.vue?vue&type=script&lang=js"

import "./perfil.vue?vue&type=style&index=0&id=64d65d5f&scoped=true&lang=css"
import "./perfil.vue?vue&type=style&index=1&id=64d65d5f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d65d5f"]])

export default __exports__